/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M17.965 13.806a2.082 2.082 0 0 0-2.947 0l-1.322 1.32A39.099 39.099 0 0 1 8.872 10.3l1.322-1.322a2.085 2.085 0 0 0 0-2.948l-1.77-1.768a2.13 2.13 0 0 0-2.945 0l-.97.97a2.926 2.926 0 0 0-.368 3.67 39.133 39.133 0 0 0 10.951 10.96 2.956 2.956 0 0 0 3.667-.37l.97-.97a2.085 2.085 0 0 0 0-2.948l-1.764-1.768Z"
})), "0 0 24 24", "Phone");